module.exports = __webpack_public_path__ + "img/04-Shop_Persona.6caab9c7.jpg";